var map = {
	"./#10d829.png": [
		53547,
		547
	],
	"./#8c060c.png": [
		61457,
		457
	],
	"./#FA091B.png": [
		85536,
		536
	],
	"./#FAEC09.png": [
		45801,
		801
	],
	"./#FFFFFF.png": [
		93987,
		987
	],
	"./#f5646f.png": [
		88066,
		66
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 29847;
module.exports = webpackAsyncContext;